import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Container as MUIContainer, useTheme } from "@mui/material";

export const Container = styled(Paper)(({ theme }) => ({
	borderRadius: theme.spacing(1),
	boxShadow: theme.shadows[5]
}));

export const ContentContainer = ({ backgroundColor = "transparent", children, style = {}, ...rest } = {}) => {
	return (
		<Box
			{...rest}
			style={{ ...style, backgroundColor }}
		>
			<MUIContainer
				style={{
					margin: "0 auto",
					maxWidth: 960
				}}
			>
				{children}
			</MUIContainer>
		</Box>
	);
};

export const ContentContainerBottom = props => {
	return <ContentContainer {...props} />;
};

export const ContentContainerTop = props => {
	const { children, ...rest } = props;
	const theme = useTheme();
	return (
		<ContentContainer
			{...rest}
			backgroundColor="white"
		>
			<Box sx={{ paddingBottom: theme.spacing(2), paddingTop: theme.spacing(12), position: "relative" }}>
				{children}
			</Box>
		</ContentContainer>
	);
};